module.exports = __webpack_public_path__ + "img/AB5_4968.206ed769.jpg";